import React, { Component } from "react";
import axios from "axios";

const API_PATH =
  "https://samarth-portfolio-server.herokuapp.com/api/send_email";

export default class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      subject: "",
      email: "",
      message: "",
      mailSent: false,
      error: null
    };
  }

  handleFormSubmit(event) {
    event.preventDefault();
    this.setState({ error: null });
    if (
      this.state.name == "" ||
      this.state.email == "" ||
      this.state.message == ""
    ) {
      this.setState({ error: "Please enter name, email and message" });
      return;
    }
    let headers = new Headers();

    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");
    headers.append("Origin", "http://localhost:3000");
    headers.append("GET", "POST", "OPTIONS");
    axios({
      method: "post",
      url: `${API_PATH}`,
      headers: headers,
      data: this.state
    })
      .then(result => {
        console.log(result.data);
        console.log(result.status);
        this.setState({
          mailSent: result.data.sent,
          error: null
        });
      })
      .catch(error => {
        console.log(error);
        this.setState({
          mailSent: false,
          error: error.message
        });
      });
  }
  render() {
    return (
      <section className="colorlib-contact" data-section="contact">
        <div className="colorlib-narrow-content">
          <div className="row">
            <div
              className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box"
              data-animate-effect="fadeInLeft"
            >
              <span className="heading-meta">Get in Touch</span>
              <h2 className="colorlib-heading">Contact</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div
                className="colorlib-feature colorlib-feature-sm animate-box"
                data-animate-effect="fadeInLeft"
              >
                <div className="colorlib-icon">
                  <i className="icon-globe-outline"></i>
                </div>
                <div className="colorlib-text">
                  <p>
                    <a href="mailto: samarthparikh62@gmail.com" target="_blank">
                      samarthparikh62@gmail.com
                    </a>
                  </p>
                </div>
              </div>

              <div
                className="colorlib-feature colorlib-feature-sm animate-box"
                data-animate-effect="fadeInLeft"
              >
                <div className="colorlib-icon">
                  <i className="icon-map"></i>
                </div>
                <div className="colorlib-text">
                  <p>Cambridge MA 02139</p>
                </div>
              </div>
{/*
              <div
                className="colorlib-feature colorlib-feature-sm animate-box"
                data-animate-effect="fadeInLeft"
              >
                <div className="colorlib-icon">
                  <i className="icon-phone"></i>
                </div>
                <div className="colorlib-text">
                  <p>
                    <a href="tel://">+1 252 347-1259</a>
                  </p>
                </div>
              </div>
    */}
            </div>
            <div className="col-md-7 col-md-push-1">
              <div className="row">
                <div
                  className="col-md-10 col-md-offset-1 col-md-pull-1 animate-box"
                  data-animate-effect="fadeInRight"
                >
                  <form action="#" method="post" id="contact-form">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        placeholder="Name"
                        value={this.state.name}
                        onChange={e => this.setState({ name: e.target.value })}
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Email"
                        name="email"
                        value={this.state.email}
                        onChange={e => this.setState({ email: e.target.value })}
                      />
                    </div>
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Subject"
                        name="subject"
                        value={this.state.subject}
                        onChange={e =>
                          this.setState({ subject: e.target.value })
                        }
                      />
                    </div>
                    <div className="form-group">
                      <textarea
                        name="message"
                        id="message"
                        cols="30"
                        rows="7"
                        className="form-control"
                        placeholder="Message"
                        value={this.state.message}
                        onChange={e =>
                          this.setState({ message: e.target.value })
                        }
                      ></textarea>
                    </div>
                    <div className="form-group">
                      <input
                        type="submit"
                        name="submit"
                        id="submit"
                        value="Submit"
                        className="btn btn-primary btn-send-message"
                        onClick={e => this.handleFormSubmit(e)}
                      />
                    </div>
                    <div>
                      {this.state.mailSent && (
                        <div>
                          <strong>
                            Thanks for reaching out! I'll follow up with you as
                            soon as possible.
                          </strong>
                        </div>
                      )}
                    </div>
                    <div>
                      {this.state.error && <div>{this.state.error}</div>}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
